import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Logo } from "@/components/site/Logo";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      toast.success("Welcome back.");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-forest-deep px-5 grain">
      <div className="w-full max-w-md rounded-3xl bg-cream p-10 border border-clubborder">
        <Logo />
        <h1 className="font-serif text-4xl mt-8 mb-2">Members only.</h1>
        <p className="text-ink/50 text-sm mb-8">Sign in to view your leads.</p>
        <form onSubmit={submit} className="space-y-6" data-testid="admin-login-form">
          <label className="block">
            <span className="block text-xs uppercase tracking-[0.14em] text-ink/50 mb-1">Email</span>
            <input data-testid="admin-email" type="email" className="ledger-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@theeventclub.ca" />
          </label>
          <label className="block">
            <span className="block text-xs uppercase tracking-[0.14em] text-ink/50 mb-1">Password</span>
            <input data-testid="admin-password" type="password" className="ledger-input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </label>
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full rounded-full bg-forest text-cream py-3.5 font-medium hover:bg-forest-deep transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
